import PropTypes from 'prop-types';

export const RADIOSELECT = 'radioSelect';
export const CHECKBOX = 'checkbox';
export const ZIP_CODE = 'zipCode';

/*
  Survey Section, we group questions into sections based on (1) internal logic of questions and
  (2) answer response or value props we display afterwards
*/
export const ACCOUNTANT_CHECK_SECTION = 'accountant_check_section';
export const INVOLVEMENT_IN_CLIENT_PAYROLL_SECTION = 'involvement_in_client_payroll_section';
export const FIRST_CLIENT_PAYROLL_SECTION = 'first_client_payroll_section';
export const NUMBER_OF_ACCOUNTANTS_SECTION = 'number_of_accountants_section';
export const ROLE_AT_FIRM_SECTION = 'role_at_firm_section';
export const SERVICES_OFFERED_SECTION = 'services_offered_section';
export const OTHER_PAYROLL_PROVIDERS_USED_SECTION = 'other_payroll_providers_used_section';
export const PASSWORD_SECTION = 'password_section';

export const getCompletedStatusForSectionKey = sectionName => {
  return `${sectionName}_completed`;
};

export const SECTION_KEY_SHAPE = PropTypes.oneOf([
  ACCOUNTANT_CHECK_SECTION,
  FIRST_CLIENT_PAYROLL_SECTION,
  INVOLVEMENT_IN_CLIENT_PAYROLL_SECTION,
  NUMBER_OF_ACCOUNTANTS_SECTION,
  OTHER_PAYROLL_PROVIDERS_USED_SECTION,
  PASSWORD_SECTION,
  ROLE_AT_FIRM_SECTION,
  SERVICES_OFFERED_SECTION,
]);
